import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterErroComprometimento(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/etapas/${etapaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPainelErrosComprometimentos(ano) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/paineis/erroscomprometimentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
